import trackerInit, { voidTracker } from './tracker';
import { EnvironmentOptions, Logger, StaticTracker, Tracker } from './types';
import z from 'zod';
import debugLogger from './debug';

let instance: Tracker = voidTracker;

const proxy =
  <T extends keyof Tracker>(key: T) =>
  (...args: Parameters<Tracker[T]>) =>
    (instance[key] as any)(...args); // eslint-disable-line @typescript-eslint/no-explicit-any

const defaultTracker = Object.keys(instance).reduce((exports, key) => {
  if (typeof instance[key as keyof Tracker] === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exports[key as keyof Tracker] = proxy<any>(key);
  }

  exports.initialize = (options: EnvironmentOptions, logger?: Logger): Promise<void> => {
    try {
      instance = trackerInit(options, logger);
      return instance.awaitInitialized();
    } catch (error) {
      const warn = logger?.warn || debugLogger.warn;
      if (error instanceof z.ZodError) {
        warn('Invalid options to initialize analyticstracker.', error.message);
      } else {
        warn('Unable to initialize analyticstracker.', error);
      }
    }
    return Promise.resolve();
  };

  return exports;
}, {} as StaticTracker);

export default defaultTracker;
